module.exports = __webpack_public_path__ + "static/media/chefs-we-facilitate.c6b4d96e.jpg";